module.exports = __webpack_public_path__ + "static/media/SocialSupport.794eb5cd.svg";